<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'Home' }">
        Mon compte
      </el-breadcrumb-item>

      <el-breadcrumb-item :to="{ name: 'Voyages' }">
        Mes voyages
      </el-breadcrumb-item>

      <el-breadcrumb-item v-if="!!voyage">
        {{ voyage.libelle_voyage }}
      </el-breadcrumb-item>
    </el-breadcrumb>

    <template v-if="!!voyage">
      <el-row type="flex">
        <el-col :span="24">
          <el-card shadow="never">
            <template #header>
              <nl2br
                v-if="voyage.libelle_voyage"
                tag="span"
                :text="voyage.libelle_voyage.replace(/\\r\\n/g, '\n')"
                class-name="vv-trip__title"
              />
              <span
                v-else
                class="vv-trip__title"
              >
                Votre voyage du {{ voyage.date_depart | date }} au {{ voyage.date_retour | date }}
              </span>

              <div class="vv-trip__period">
                <template v-if="!!voyage.date_depart && !!voyage.date_retour">
                  du {{ voyage.date_depart | date }} au {{ voyage.date_retour | date }}
                </template>

                <template v-else-if="!!voyage.date_depart">
                  départ le {{ voyage.date_depart | date }}
                </template>

                <template v-else-if="!!voyage.date_retour">
                  retour le {{ voyage.date_retour | date }}
                </template>

                &nbsp;pour une durée de&nbsp;

                <template v-if="!!voyage.nombre_jours && !!voyage.nombre_nuits">
                  {{ voyage.nombre_jours }} jours / {{ voyage.nombre_nuits }} nuits
                </template>

                <template v-else-if="!!voyage.nombre_jours">
                  {{ voyage.nombre_jours }} jours
                </template>

                <template v-else-if="!!voyage.nombre_nuits">
                  {{ voyage.nombre_nuits }} nuits
                </template>
              </div>
            </template>

            <el-alert
              class="vv-trip-content__alert"
              :closable="false"
              effect="dark"
              show-icon
              :title="voyage.statut.name"
              :type="voyage.statut.typeAlerte"
            />

            <p class="vv-trip-content__info">
              <span>N° dossier&nbsp;:</span> {{ voyage.ref_dossier }}
            </p>

            <p class="vv-trip-content__info">
              <span>Destination&nbsp;:</span> {{ voyage.destination }}
            </p>

            <p class="vv-trip-content__info">
              <span>Ville de départ&nbsp;:</span> {{ voyage.ville_depart }}
            </p>

            <p
              v-if="!!voyage.lieu_prise_en_charge && voyage.type !== 'prestation_agenceweb'"
              class="vv-trip-content__info"
            >
              <span>Lieu de prise en charge&nbsp;:</span>
              <nl2br
                tag="span"
                :text="voyage.lieu_prise_en_charge.replace(/\\r\\n/g, '\n')"
              />
            </p>

            <p class="vv-trip-content__info">
              <span>Nombre de participant(s)&nbsp;:</span> {{ voyage.nb_personnes }} personne(s)
            </p>

            <p
              v-if="!!voyage.organisateur"
              class="vv-trip-content__info"
            >
              <span>Organisateur&nbsp;:</span> {{ voyage.organisateur }}
            </p>

            <el-row
              class="vv-trip-documents"
              :gutter="20"
              type="flex"
            >
              <el-col
                v-if="bulletin"
                :xs="24"
                :md="6"
              >
                <el-link
                  :href="bulletin.url"
                  icon="el-icon-document"
                  target="_blank"
                  type="primary"
                >
                  Télécharger mon bulletin d'inscription
                </el-link>
              </el-col>

              <el-col
                v-if="convocation"
                :xs="24"
                :md="6"
              >
                <el-link
                  :href="convocation.url"
                  icon="el-icon-document"
                  target="_blank"
                  type="primary"
                >
                  Télécharger ma convocation
                </el-link>
              </el-col>

              <el-col
                v-if="carnet"
                :xs="24"
                :md="6"
              >
                <el-link
                  :href="carnet.url"
                  icon="el-icon-document"
                  target="_blank"
                  type="primary"
                >
                  Télécharger mon carnet de voyage
                </el-link>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>

      <el-row type="flex">
        <el-col :span="24">
          <el-card shadow="never">
            <template #header>
              <span>Paiements</span>
            </template>

            <el-alert
              class="vv-trip-content__alert"
              :closable="false"
              effect="dark"
              show-icon
              :title="voyage.statut_paiement.name"
              :type="voyage.statut_paiement.typeAlerte"
            />

            <el-row type="flex">
              <el-col
                v-if="facture"
                :xs="24"
                :md="6"
              >
                <el-link
                  :href="facture.url"
                  icon="el-icon-document"
                  target="_blank"
                  type="primary"
                >
                  Télécharger ma facture
                </el-link>
              </el-col>
            </el-row>

            <h4 class="vv-trip-content__title">
              Prestations&nbsp;:
            </h4>

            <el-row
              v-for="prestation in prestations"
              :key="prestation.libelle"
              class="vv-trip-payment__line"
              type="flex"
            >
              <el-col
                :xs="24"
                :md="14"
              >
                {{ prestation.libelle }}
              </el-col>

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                {{ prestation.prix_unitaire | currency }} * {{ prestation.quantite }}
              </el-col>

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                {{ (prestation.prix_unitaire * prestation.quantite) | currency }}
              </el-col>
            </el-row>

            <el-row
              class="vv-trip-payment__line"
              type="flex"
            >
              <el-col
                :xs="24"
                :md="14"
              />

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                <strong>TOTAL&nbsp;:</strong>
              </el-col>

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                <strong>{{ voyage.montant_total | currency }}</strong>
              </el-col>
            </el-row>

            <el-divider />

            <h4 class="vv-trip-content__title">
              Règlements&nbsp;:
            </h4>

            <el-row
              v-for="(reglement, i) in voyage.reglements"
              :key="i"
              class="vv-trip-payment__line"
              type="flex"
            >
              <el-col
                :xs="24"
                :md="15"
              >
                {{ reglement.date | date }} - {{ reglement.methode }}
              </el-col>

              <el-col
                align="right"
                :xs="24"
                :md="9"
              >
                {{ reglement.montant | currency }}
              </el-col>
            </el-row>

            <el-row
              class="vv-trip-payment__line"
              type="flex"
            >
              <el-col
                :xs="24"
                :md="14"
              />

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                <strong>TOTAL&nbsp;:</strong>
              </el-col>

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                <strong>{{ totalReglements | currency }}</strong>
              </el-col>
            </el-row>

            <el-row
              class="vv-trip-payment__line"
              type="flex"
            >
              <el-col
                :xs="24"
                :md="14"
              />

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                <strong>SOLDE&nbsp;:</strong>
              </el-col>

              <el-col
                align="right"
                :xs="24"
                :md="5"
              >
                <strong>{{ voyage.solde_a_payer | currency }}</strong>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col
                align="right"
                :xs="24"
              >
                <span
                  v-if="voyage.date_prelevement_automatique && !datePrelevPassed"
                  class="vv-trip-payment__next_debit"
                >
                  Le prélèvement du solde est automatique et sera effectué le {{ voyage.date_prelevement_automatique | date }}
                </span>
                <span
                  v-else-if="voyage.date_prelevement_automatique && datePrelevPassed"
                  class="vv-trip-payment__next_debit"
                >
                  Votre prélèvement prévu le {{ voyage.date_prelevement_automatique | date }} a échoué, cliquez ici pour effectuer le règlement :
                </span>
                <el-button
                  v-if="voyage.statut_paiement.id === 'reste_a_payer' && voyage.statut !== 'attente' && !(voyage.date_prelevement_automatique && !datePrelevPassed)"
                  v-loading="paymentTunnel.loading"
                  size="small"
                  type="primary"
                  @click="getPaymentUrl"
                >
                  Payer mon solde en ligne
                  <i class="el-icon-bank-card el-icon-right" />
                </el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>

      <el-row
        v-if="!!assurances && assurances.length"
        class="vv-trip-assurances"
        type="flex"
      >
        <el-col :span="24">
          <el-card
            shadow="never"
          >
            <template #header>
              <span>Assurances et Garanties</span>
            </template>
            <span
              v-for="assurance in assurances"
              :key="assurance.key"
            >
              {{ assurance.name }} {{ assurance.status }}
              <br>
            </span>
          </el-card>
        </el-col>
      </el-row>

      <el-row
        v-if="voyage.segments.length > 0"
        class="vv-trip-transports"
        type="flex"
      >
        <el-col :span="24">
          <el-card shadow="never">
            <template #header>
              <span>Transports</span>
            </template>
            <div
              v-for="(segment, i) in voyage.segments"
              :key="i"
            >
              <h4>{{ segment.sens | capitalize }}</h4>
              <el-row>
                <el-col
                  :xs="24"
                >
                  <transport-segment :segment="segment" />
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row
        class="vv-trip-participants"
        type="flex"
      >
        <el-col :span="24">
          <el-card shadow="never">
            <template #header>
              <span>Participant{{ voyage.nb_personnes !== 1 ? 's' : '' }}</span>
            </template>

            <el-table
              :data="voyage.participants"
              stripe
            >
              <el-table-column
                label="Civilité"
                prop="civilite.name"
                width="80"
              />

              <el-table-column
                label="Nom / Prénom"
                prop="nom_prenom"
              />

              <el-table-column
                label="Numéro d'urgence"
                prop="telephone_urgence"
              />

              <el-table-column label="Date de Naissance">
                <template #default="{ row }">
                  <span v-if="!!row.date_naissance">{{ row.date_naissance | date }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>

      <el-row type="flex">
        <el-col :span="24">
          <el-card
            v-if="!!voyage.adresse_livraison_cdv"
            shadow="never"
          >
            <template #header>
              <span>Informations client</span>
            </template>
            <span>
              Adresse de livraison du carnet de voyage : {{ voyage.adresse_livraison_cdv | adresse }}
              <br>
            </span>
          </el-card>
        </el-col>
      </el-row>

      <el-row type="flex">
        <el-col :span="24">
          <el-card
            shadow="never"
          >
            <template #header>
              <span>Formalités liées à votre voyage</span>
            </template>
            <nl2br
              tag="div"
              :text="voyage.formalites.replace(/\\r\\n/g, '\n')"
            />
            <br v-if="voyage.formalites">
            Les formalités d'entrées officielles des pays de destination sont sujettes à révision. Pour les ressortissants français, elles sont à consulter
            jusqu'au jour du départ : <a
              href="https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays-destination/"
              target="_blank"
            >https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays-destination/</a>.
          </el-card>
        </el-col>
      </el-row>

      <el-row type="flex">
        <el-col :span="24">
          <el-card
            v-if="voyage.agence !== undefined"
            shadow="never"
          >
            <template #header>
              <el-row
                align="middle"
                type="flex"
              >
                <el-col :span="12">
                  <span>Agence en charge de votre réservation</span>
                </el-col>

                <el-col
                  align="right"
                  :span="12"
                >
                  <el-button
                    v-loading="agence.saving"
                    size="small"
                    type="primary"
                    @click="saveAgence"
                  >
                    Définir comme agence de préférence
                  </el-button>
                </el-col>
              </el-row>
            </template>

            <agence
              v-model="voyage.agence"
              :should-hide-internet-coordinates="voyage.type === 'prestation_agenceweb'"
            />
          </el-card>
        </el-col>
      </el-row>

      <el-dialog
        :before-close="getVoyage"
        center
        title="Paiement sécurisé"
        :visible.sync="!!paymentTunnel.show"
      >
        <iframe
          class="popin-paiement"
          :src="voyage.urlPaiement"
        />
      </el-dialog>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      agence: {
        saving: false
      },
      paymentTunnel: {
        loading: false,
        show: false
      }
    }
  },

  computed: {
    ...mapGetters(['profil', 'voyage']),

    assurances () {
      const translateKey = (key) => ({
        assur_annul: 'Assurance Annulation',
        ass_multirisque: 'Assistance Multirisques',
        ass_rapatr: 'Assurance Rapatriement',
        garantie_annul: 'Garantie Annulation',
        compl_protect_plus: 'Complémentaire VERDIÉ Protect Plus'
      }[key])

      const translateStatus = (status) => ({
        refusee: 'refusée',
        incluse: 'incluse',
        souscrite: 'souscrite'
      }[status])

      return this.voyage
        ? Object.keys(this.voyage.infos_assurances)
          .filter((key) => !!this.voyage.infos_assurances[key])
          .map((key) => ({
            key: key,
            name: translateKey(key),
            status: translateStatus(this.voyage.infos_assurances[key])
          }))
        : []
    },

    bulletin () {
      return this.voyage.documents ? this.voyage.documents.find(d => d.type === 'bulletin') : null
    },

    carnet () {
      return this.voyage.documents ? this.voyage.documents.find(d => d.type === 'carnet') : null
    },

    convocation () {
      return this.voyage.documents ? this.voyage.documents.find(d => d.type === 'convocation') : null
    },

    facture () {
      return this.voyage.documents ? this.voyage.documents.find(d => d.type === 'facture') : null
    },

    prestations () {
      return this.voyage.prestations.filter(p => p.prix_unitaire !== 0 && p.quantite !== 0)
    },

    totalReglements () {
      return this.voyage.reglements.reduce((a, r) => a + parseFloat(r.montant), 0.0)
    },

    datePrelevPassed () {
      return this.isDatePrelevPassed()
    }
  },

  created () {
    // Récupère les informations du voyage demandé
    this.getVoyage()
  },

  methods: {
    getPaymentUrl () {
      // Démarre l'indicateur de chargement
      this.paymentTunnel.loading = true

      // Récupère l'URL du tunnel de paiement
      this.$store.dispatch('getPaymentUrl', this.$route.params.id)
        .then(() => {
          // Affiche la pop-in contenant le tunnel de paiement
          this.paymentTunnel.show = true
        })
        .finally(() => {
          // Stop l'indicateur de chargement
          this.paymentTunnel.loading = false
        })
    },

    getVoyage () {
      // Démarre l'indicateur de chargement
      this.$store.commit('startLoading')

      // Masque la pop-in contenant le tunnel de paiement
      this.paymentTunnel.show = false

      // Récupère les informations du voyage
      Promise.all([
        this.$store.dispatch('getAgences'),
        this.$store.dispatch('getVoyage', this.$route.params.id)
      ])
        .catch(error => {
          if (error.response && error.response.status === 404) {
            // Envoi une notification
            this.$message({
              duration: 5000,
              message: `Aucun voyage ne correspond à l'identifiant « ${this.$route.params.id} »`,
              showClose: true,
              type: 'error'
            })

            // Redirige vers la liste des voyages
            this.$router.push({ name: 'Voyages' })
          }
          if (error.response && error.response.status === 409) {
            // Envoi une notification
            this.$message({
              duration: 10000,
              message: 'Le compte actuel n’est pas celui avec lequel vous avez acheté le voyage en attente de règlement de solde. ' +
                'Veuillez s’il vous plaît vous déconnecter de ce compte et vous connecter au compte dont l’identifiant est' +
                ' l’adresse email sur laquelle vous avez reçu l’email d’information.',
              showClose: true,
              type: 'error'
            })

            // Redirige vers la liste des voyages
            this.$router.push({ name: 'Voyages' })
          }
        })
        .finally(() => {
          // Stop l'indicateur de chargement
          this.$store.commit('stopLoading')
        })
    },

    isDatePrelevPassed () {
      const date = new Date()
      const datePaiementAuto = new Date(this.voyage.date_prelevement_automatique)
      date.setHours(0, 0, 0, 0)
      datePaiementAuto.setHours(0, 0, 0, 0)
      return date > datePaiementAuto
    },

    saveAgence () {
      // Démarre l'indicateur de chargement
      this.agence.saving = true

      // Exécute l'enregistrement auprès de l'api
      this.$store.dispatch('setUserInfos', {
        agencePreferee: this.voyage.agence.code
      })
        .then(() => {
          // Envoi une notification
          this.$message({
            duration: 5000,
            message: 'Enregistrement de votre nouvelle agence effectué avec succès',
            showClose: true,
            type: 'success'
          })
        })
        .finally(() => {
          // Stop l'indicateur de chargement
          this.agence.saving = false
        })
    }
  }
}
</script>

<style scoped>
.popin-paiement {
  width: 100%;
  height: 500px;
  margin-top: 30px;
}
</style>
